var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3664 14.2602V21L12.9766 20.1219V14.7321C13.4641 14.6297 13.9281 14.4704 14.3664 14.2602ZM11.7062 3C8.5538 3 6 5.554 6 8.7062C6 11.8578 8.554 14.414 11.7062 14.414C14.8584 14.414 17.4124 11.86 17.4124 8.7078C17.4124 5.5562 14.8584 3 11.7062 3ZM14.6484 7.4796L11.5124 10.6156C11.2741 10.8539 10.8905 10.8539 10.6522 10.6156L8.7624 8.72732L9.62256 7.86716L11.0827 9.32732L13.7881 6.62032L14.6484 7.4796ZM11.7062 3.95C14.332 3.95 16.4624 6.0796 16.4624 8.7062C16.4624 11.332 14.3328 13.4624 11.7062 13.4624C9.0804 13.4616 6.95 11.3342 6.95 8.7062C6.95 6.0796 9.0804 3.95 11.7062 3.95ZM11.7062 4.4C14.0844 4.4 16.0124 6.32812 16.0124 8.7062C16.0124 11.0843 14.0843 13.0124 11.7062 13.0124C9.32812 13.0124 7.4 11.0843 7.4 8.7062C7.4 6.32812 9.32812 4.4 11.7062 4.4ZM12.5265 19.8382L11.7062 19.3202L10.8859 19.8382V14.8078C11.1538 14.8437 11.4281 14.8617 11.7062 14.8617C11.9843 14.8617 12.2585 14.8437 12.5265 14.8078V19.8382ZM10.4359 20.1218L9.04608 20.9999V14.2601C9.48202 14.4703 9.94842 14.6304 10.4359 14.732V20.1218Z",
    fill: "#32589F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeicon);
export default __webpack_public_path__ + "static/media/badgeicon.d64ff539b0c7bd2aa7f3a1805fd79b88.svg";
export { ForwardRef as ReactComponent };